<script lang="ts">
	import type { ComponentEditingProps } from "#lib/components/page/ComponentProps.js";
	import EditorInset from "#lib/components/page/editing/EditorInset.svelte";

	let { children }: ComponentEditingProps = $props();

	export function value(out: unknown) {
		void out;
	}

	export function validate(): boolean {
		return true;
	}
</script>

<EditorInset>
	<div class="flex flex-col gap-4">
		{@render children?.()}
	</div>
</EditorInset>
